import React, { useState, useEffect } from "react";
import {
  MinusCircleOutlined,
  PlusOutlined,
  CloseOutlined,
  EditOutlined,
} from "@ant-design/icons";
import {
  Button,
  Form,
  Input,
  Card as AntdCard,
  Row,
  Col,
  Space,
  Card,
  DatePicker,
  Checkbox,
  Menu,
  Dropdown,
  ColorPicker,
  Modal,
  Tag,
} from "antd";
import { v4 as uuidv4 } from "uuid";
import { useForm } from "antd/es/form/Form";
import { Color } from "antd/es/color-picker";

interface CustomizeFormProps {
  setMembers: React.Dispatch<React.SetStateAction<string[]>>;
  setSubmitted: React.Dispatch<React.SetStateAction<boolean>>;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  labels: string[];
  setLabels: React.Dispatch<React.SetStateAction<string[]>>;
  backgroundImages: { [key: string]: string };
  labelCustomizeActivity: string;
  setLabelCustomizeActivity: React.Dispatch<React.SetStateAction<string>>;
  step: number;
  title: string;
  content: string;
}

interface ButtonData {
  text: string;
  color: string;
}

export const CustomizeForm: React.FC<CustomizeFormProps> = ({
  setMembers,
  setSubmitted,
  setActiveTab,
  backgroundImages,
  labelCustomizeActivity,
  setLabelCustomizeActivity,
}) => {
  const [questionForm] = useForm();
  const [openButtonConfig, setOpenButtonConfig] = useState(false);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [selectedColor, setSelectedColor] = useState("#1890ff");
  const [buttonForm] = Form.useForm();
  const [pageForm] = Form.useForm();
  const onFinish = (values: { names: string[] }) => {
    console.log("onFinish", values);

    setMembers(values.names || []);
    setSubmitted(true);
    setActiveTab("2");
    console.log("Submitted members:", values.names);
  };

  const onCancel = () => {
    setMembers([]);
    setSubmitted(false);
    console.log("Cancel button clicked: Resetting members and submitted state");
  };

  const handleEditButton = (index: number) => {
    setEditingIndex(index);
    setOpenButtonConfig(true);
  };

  const handleAddButton = (fields: any[], operation: any) => {
    operation.add({ text: "ปุ่มใหม่", color: "#1890ff" });
    setEditingIndex(fields.length);
    setOpenButtonConfig(true);
  };
  const handleAddNewButton = (pageIndex: number) => {
    buttonForm.setFieldValue("pageIndex", pageIndex);
    setOpenButtonConfig(true);

  };
  useEffect(() => {
    if (editingIndex !== null) {
      const initialColor =
        buttonForm.getFieldValue(["buttons", editingIndex, "color"]) ||
        "#1890ff";
      setSelectedColor(initialColor);
    }
  }, [editingIndex, buttonForm]);
  const saveButtonConfig = (value: {
    pageIndex: number;
    buttonColor: Color;
    buttonText: string;
  }) => {
    const newButton = {
      color: value.buttonText,
      text: value.buttonColor.toHexString(),
      link: "",
    };
    // console.log(newButton);
    const oldform = questionForm.getFieldValue([
      "details",
      value.pageIndex,
      "button",
    ]);
    const form = questionForm.getFieldsValue();
    form.details[value.pageIndex].button = [...oldform, newButton];
    console.log(form);
    pageForm.setFieldsValue(form);

   buttonForm.resetFields();
    setOpenButtonConfig(false);
  };
  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <AntdCard
          className="shadow-sm rounded-xl p-8 relative h-full"
          style={{
            backgroundImage: `url(${backgroundImages.customizeActivity})`,
            backgroundSize: "cover",
          }}
        >
          <div className="absolute top-4 left-4">
            <Input
              value={labelCustomizeActivity}
              onChange={(e) => setLabelCustomizeActivity(e.target.value)}
              className="w-24 border border-gray-300 rounded-xl p-1 text-xs"
              placeholder="Label"
            />
          </div>
          <h3 className="text-3xl font-semibold text-gray-700 mb-6">
            Customize activity
          </h3>

          <Form name="dynamic_form" onFinish={onFinish} layout="vertical">
            <Form.List name="names">
              {(fields, { add, remove }) => (
                <>
                  {fields.map((field) => (
                    <Form.Item key={field.key} className="mb-4">
                      <div className="flex items-center space-x-3">
                        <Form.Item {...field} noStyle>
                          <Input className="w-full p-4 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-400 focus:border-transparent transition" />
                        </Form.Item>
                        <MinusCircleOutlined
                          className="text-red-500 cursor-pointer hover:text-red-700 transition"
                          onClick={() => remove(field.name)}
                        />
                      </div>
                    </Form.Item>
                  ))}

                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                      className="w-full py-3 border border-gray-300 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition"
                    >
                      เพิ่มข้อมูล
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>

            <Form.Item>
              <div className="flex justify-end space-x-4">
                <Button
                  onClick={onCancel}
                  className="py-3 px-6 bg-gray-500 text-white hover:bg-gray-600 rounded-xl transition"
                >
                  ยกเลิก
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="py-3 px-6 bg-green-600 text-white hover:bg-green-700 rounded-xl transition"
                >
                  บันทึก
                </Button>
              </div>
            </Form.Item>
          </Form>
        </AntdCard>
      </Col>

      {/*สร้าง Page ใหม่*/}
      <Col span={24}>
        <Form
          form={questionForm}
          onFinish={(values) => {
            console.log("Form values:", values);
          }}
        >
          <Form.List name="details">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }, index) => (
                  <div className="mb-2" key={key}>
                    <Card
                      title={
                        <div className="flex flex-col space-y-1">
                          {/* เก็บ Title , Sub Title */}
                          <Form.Item
                            {...restField}
                            name={[name, "pageTitle"]}
                            label="หัวข้อ"
                            className="mb-3"
                          >
                            <Input
                              placeholder="กรอกหัวข้อ"
                              className="w-[300px] rounded-md border border-gray-300 shadow-sm py-2 px-3"
                            />
                          </Form.Item>
                          <Form.Item
                            name={[name, "subTitle"]}
                            label="หัวข้อย่อย"
                            className="mb-3"
                          >
                            <Input
                              placeholder="กรอกหัวข้อย่อย"
                              className="w-[300px] rounded-md border border-gray-300 shadow-sm py-2 px-3"
                            />
                          </Form.Item>
                        </div>
                      }
                      extra={
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      }
                      className="p-4 rounded-lg shadow-sm"
                    >
                      {/* ไว้เก็บเพจหน้า id */}
                      <Form.Item
                        name={[name, "pageId"]}
                        initialValue={`prandom${{ name }}`}
                        noStyle
                      >
                        <Input type="hidden" />
                      </Form.Item>

                      {/* เก็บ Field */}
                      <Form.Item>
                        <Form.List name={[name, "field"]}>
                          {(subFields, subOpt) => (
                            <div className="flex flex-col gap-4">
                              {/* Header และปุ่ม Question */}
                              <div className="flex justify-end gap-2 sticky top-0 z-10 bg-white p-4 border-b border-gray-300">
                                <div className="flex items-end gap-2">
                                  <Button
                                    type="dashed"
                                    onClick={() =>
                                      subOpt.add({ type: "Header", header: "" })
                                    }
                                    className="text-blue-600"
                                  >
                                    + เพิ่มหัวข้อ
                                  </Button>
                                </div>
                                <Dropdown
                                  overlay={
                                    <Menu>
                                      <Menu.Item
                                        key="Text"
                                        onClick={() =>
                                          subOpt.add({
                                            type: "Text",
                                            header: "",
                                          })
                                        }
                                      >
                                        Text
                                      </Menu.Item>
                                      <Menu.Item
                                        key="Date"
                                        onClick={() =>
                                          subOpt.add({
                                            type: "Date",
                                            header: "",
                                          })
                                        }
                                      >
                                        Date
                                      </Menu.Item>
                                      <Menu.Item
                                        key="Dropdown"
                                        onClick={() =>
                                          subOpt.add({
                                            type: "Dropdown",
                                            header: "",
                                          })
                                        }
                                      >
                                        Dropdown
                                      </Menu.Item>
                                      <Menu.Item
                                        key="Checkbox"
                                        onClick={() =>
                                          subOpt.add({
                                            type: "Checkbox",
                                            header: "",
                                          })
                                        }
                                      >
                                        Checkbox
                                      </Menu.Item>
                                    </Menu>
                                  }
                                >
                                  <Button
                                    type="dashed"
                                    className="text-blue-600"
                                  >
                                    + เพิ่มคำถาม
                                  </Button>
                                </Dropdown>
                              </div>

                              {subFields.map((subField, index) => (
                                <div
                                  key={subField.key}
                                  className="p-4 border border-gray-300 rounded-xl flex flex-col gap-2"
                                >
                                  <Space align="start">
                                    <Form.Item
                                      label={`คำถามที่ ${index + 1}`}
                                      name={[subField.name, "header"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "กรุณากรอกคำถาม",
                                        },
                                      ]}
                                    >
                                      <Input placeholder="กรอกคำถาม" />
                                    </Form.Item>

                                    {/* แสดงไทป์ของฟิลด์ */}
                                    <Form.Item noStyle shouldUpdate>
                                      {({ getFieldValue }) => {
                                        const type = getFieldValue([
                                          "details",
                                          name,
                                          "field",
                                          subField.name,
                                          "type",
                                        ]);

                                        return type ? (
                                          <Tag color="blue">{type}</Tag>
                                        ) : null;
                                      }}
                                    </Form.Item>

                                    <CloseOutlined
                                      onClick={() =>
                                        subOpt.remove(subField.name)
                                      }
                                    />
                                  </Space>

                                  <Form.Item noStyle shouldUpdate>
                                    {({ getFieldValue }) => {
                                      const type = getFieldValue([
                                        "details",
                                        name,
                                        "field",
                                        subField.name,
                                        "type",
                                      ]);

                                      if (
                                        type === "Dropdown" ||
                                        type === "Checkbox"
                                      ) {
                                        return (
                                          <>
                                            <Form.List
                                              name={[subField.name, "options"]}
                                            >
                                              {(optionFields, optionOpt) => (
                                                <div className="flex flex-col">
                                                  {optionFields.map(
                                                    (optionField, optIndex) => (
                                                      <Space
                                                        key={optionField.key}
                                                        align="baseline"
                                                      >
                                                        <Form.Item
                                                          label={`ตัวเลือกที่ ${
                                                            optIndex + 1
                                                          } :`}
                                                          name={[
                                                            optionField.name,
                                                            "text",
                                                          ]}
                                                          rules={[
                                                            {
                                                              required: true,
                                                              message:
                                                                "กรุณากรอกตัวเลือก",
                                                            },
                                                          ]}
                                                        >
                                                          <span />
                                                        </Form.Item>

                                                        {type ===
                                                          "Checkbox" && (
                                                          <Form.Item
                                                            noStyle
                                                            name={[
                                                              optionField.name,
                                                              "checked",
                                                            ]}
                                                            valuePropName="checked"
                                                          >
                                                            <Checkbox />
                                                          </Form.Item>
                                                        )}

                                                        <Form.Item
                                                          name={[
                                                            optionField.name,
                                                            "text",
                                                          ]}
                                                        >
                                                          <Input placeholder="กรอกตัวเลือก" />
                                                        </Form.Item>

                                                        <CloseOutlined
                                                          onClick={() =>
                                                            optionOpt.remove(
                                                              optionField.name
                                                            )
                                                          }
                                                        />
                                                      </Space>
                                                    )
                                                  )}
                                                  <Button
                                                    type="dashed"
                                                    onClick={() =>
                                                      optionOpt.add()
                                                    }
                                                    className="text-blue-600 w-fit"
                                                  >
                                                    <span className="text-lg w-[200px]">
                                                      +
                                                    </span>
                                                  </Button>
                                                </div>
                                              )}
                                            </Form.List>
                                          </>
                                        );
                                      } else if (type === "Date") {
                                        return (
                                          <Form.Item
                                            name={[subField.name, "date"]}
                                            rules={[
                                              {
                                                required: true,
                                                message: "กรุณาเลือกวันที่",
                                              },
                                            ]}
                                          >
                                            <DatePicker className="w-[200px]" />
                                          </Form.Item>
                                        );
                                      }
                                      return null;
                                    }}
                                  </Form.Item>
                                </div>
                              ))}
                            </div>
                          )}
                        </Form.List>
                      </Form.Item>
                        {/* Button Config */}
                      <Button onClick={() => handleAddNewButton(name)}>
                        Add Button
                      </Button>
                      <Form.List name={[name, "button"]}>
                        {(subfields, { add, remove }) => (
                          <>
                            {subfields.map((subfield) => (
                              <Space
                                key={key}
                                style={{ display: "flex", marginBottom: 8 }}
                                align="baseline"
                              >
                                <Form.Item
                                  {...restField}
                                  name={[subfield.name, "text"]}
                                >
                                  <Input placeholder="Text" />
                                </Form.Item>
                                <Form.Item
                                  {...restField}
                                  name={[subfield.name, "color"]}
                                >
                                  <Input placeholder="Color" />
                                </Form.Item>{" "}
                                <Form.Item
                                  {...restField}
                                  name={[subfield.name, "link"]}
                                >
                                  <Input placeholder="link" />
                                </Form.Item>
                                <MinusCircleOutlined
                                  onClick={() => remove(name)}
                                />
                              </Space>
                            ))}
                          </>
                        )}
                      </Form.List>
                    </Card>
                  </div>
                ))}

                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    className="w-[200px] py-3 border border-gray-300 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition"
                  >
                    เพิ่มหน้าใหม่
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              ตกลง
            </Button>
          </Form.Item>
        </Form>
      </Col>
      {/* Popup สำหรับแก้ไขปุ่ม */}
      <Modal
        title="แก้ไขปุ่ม"
        open={openButtonConfig}
        onCancel={() => {
          setOpenButtonConfig(false);
          setEditingIndex(null);
        }}
        footer={null}
      >
        <Form form={buttonForm} onFinish={saveButtonConfig}>
          <Form.Item name="pageIndex">
            <Input placeholder="hide !!" />
          </Form.Item>
          <Form.Item
            label="ชื่อปุ่ม"
            name="buttonText"
            rules={[
              {
                required: true,
                message: "กรุณากรอกชื่อปุ่ม",
              },
            ]}
          >
            <Input placeholder="กรอกชื่อปุ่ม" />
          </Form.Item>

          <Form.Item label="เลือกสี" name="buttonColor"  rules={[
              {
                required: true,
                message: "กรุณากรอก",
              },
            ]}>
            <ColorPicker format="hex" value={selectedColor} showText />
          </Form.Item>
          <Form.Item label="ลิงค์" name="buttonLink"  rules={[
              {
                required: true,
                message: "กรุณากรอก",
              },
            ]}>
            <Input />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                backgroundColor: selectedColor,
              }}
            >
              บันทึก
            </Button>
            <Button
              onClick={() => {
                setOpenButtonConfig(false);
                setEditingIndex(null);
              }}
            >
              ยกเลิก
            </Button>
            <Button className="ml-[8px]" type="default">
              ลบปุ่ม
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </Row>
  );
};
